import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { NoteService } from "../../../Component/Api/Note/NoteService";
import { DataTable } from "../../../Component/Common/Components/DataTable/DataTable";
import { Note } from "../../../Component/Model/Dto/Note";
import { EntriesPerPage } from "../../../Component/Model/Table/Table";
import { defaultObject } from "../../../Helpers/typescriptHelper";
import { NoteModal } from "../../Common/Notes/NoteModal";
import { NotesTableMapper } from "../../Common/Notes/NotesTableColumn";


interface IProps {
    scorecardId: string;
    noteId: string;
}

export const AllNotesDataTable = (props: IProps) => {

    const [previewPopup, setPreviewPopup] = React.useState<boolean>(false);
    const [notesData, setNotesData] = React.useState<Note.SearchDtoIn[]>(defaultObject);
    const [entriesPerPage, setEntriesPerPage] = React.useState<EntriesPerPage>({ defaultValue: 10 });
    const [pageNumber, setPageNumber] = React.useState<number>(1);
    const [searchValue, setSearchValue] = React.useState<string>('');
    const [filteredItemsCount, setFilteredItemsCount] = React.useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = React.useState<number>(0);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [selectedNoteId, setSelectedNoteId] = React.useState<string>("");

    const notesSearchRequest: Note.SearchRequest = {
        PageNumber: pageNumber,
        PageSize: entriesPerPage.defaultValue as number,
        ScorecardId: props.scorecardId,
        SortColumnNames: [],
        SortDirections: [],
        SearchValue: searchValue,
        ScorecardElements: [1],
        LinkedEntityId: null,
        CreatedByUserIds: null,
        ResponsibleUserIds: null,
        Draw: 2,
        SearchLinkedEntity: true,
        ScorecardElementTypes: null
    };


    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    }

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }

    const searchValueChanged = (value: string) => {
        setSearchValue(value);
    }

    const handleClosePopup = () => {
        setPreviewPopup(false);
        setSelectedNoteId("");
    }

    const handleEdit = (id: string) => {
        setSelectedNoteId(id);
        setPreviewPopup(true);
    }

    const handleDelete = async (id: string) => {
        try {
            await NoteService.DeleteNote(id, props.scorecardId);
            toast.success("Note deleted succesfully")
            fetchData();

        } catch (error) {
            console.log(error)
        }

    }

    const handleEmail = async (id: string) => {
        try {
            await NoteService.SendNoteToResponsibleUser(id);
            toast.success("Note email sent")
            fetchData();

        } catch (error) {
            console.log(error)
        }
    }

    const fetchData = async () => {
        setIsLoading(true);
        try {
            let searchResult = await NoteService.SearchNotes(notesSearchRequest);
            if (searchResult.data) {
                setNotesData(searchResult.data.data);
                setFilteredItemsCount(searchResult.data.filteredItemsCount);
                setTotalItemsCount(searchResult.data.totalItemsCount);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false);
        }

    };

    useEffect(() => {
        fetchData();
        setSelectedNoteId(props.noteId);
        setPreviewPopup(true)
    }, [entriesPerPage, pageNumber, searchValue]); // eslint-disable-line react-hooks/exhaustive-deps

    const notesTableData = NotesTableMapper(notesData, handleEdit, handleDelete, handleEmail);
    return (
        <>
            <DataTable
                table={notesTableData}
                entriesPerPage={entriesPerPage}
                pageNumber={pageNumber}
                filteredItemsCount={filteredItemsCount}
                totalItemsCount={totalItemsCount}
                entriesPerPageChanged={entriesPerPageChanged}
                pageNumberChanged={pageNumberChanged}
                isLoading={isLoading}
                canSearch={true}
                searchValueChanged={searchValueChanged}
            ></DataTable>

            {previewPopup &&
                <NoteModal
                    id={selectedNoteId}
                    scorecardId={props.scorecardId}
                    handleCancel={handleClosePopup}
                    refreshTable={fetchData}
                    setNoteId={setSelectedNoteId}
                    showNoteModal={previewPopup}
                    closeNoteModal={handleClosePopup} />
            }
        </>
    )
}